module.exports = __webpack_public_path__ + "img/comment.f22cfa3d.svg";